import { type BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import { type SocietyProfileWorkflowInstanceParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/workflow/[workflowId]/instance/[workflowInstanceId]";
import { type SocietyWorkflowInstanceBodyInput } from "shared/api/types/society/[societyId]/workflow/[workflowId]/instance";
import { type WorkflowInstanceView } from "shared/mappers/database/workflow/workflow-instance";
import { type WorkflowInstanceStopped } from "shared/workflow/workflow-instance";
import { type WorkflowInstancePayloadValueBase } from "shared/workflow/workflow-instance-payload";
export const postSocietyProfileWorkflowInstanceIdContract: BaseApiContract<
  SocietyProfileWorkflowInstanceParamsInput,
  SocietyWorkflowInstanceBodyInput,
  WorkflowInstanceStopped
> = {
  method: HttpMethod.POST,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/workflow/[workflowId]/instance/[workflowInstanceId]",
  paramsType: {} as SocietyProfileWorkflowInstanceParamsInput,
  bodyType: {} as SocietyWorkflowInstanceBodyInput,
  responseType: {} as WorkflowInstanceStopped,
};
export const getSocietyProfileWorkflowInstanceIdContract: BaseApiContract<
  SocietyProfileWorkflowInstanceParamsInput,
  undefined,
  WorkflowInstanceView<WorkflowInstancePayloadValueBase>
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/workflow/[workflowId]/instance/[workflowInstanceId]",
  paramsType: {} as SocietyProfileWorkflowInstanceParamsInput,
  responseType:
    undefined as unknown as WorkflowInstanceView<WorkflowInstancePayloadValueBase>,
};
